import { createContext } from "react";

export type VideoCallContextType = {
  isCameraDisabled: boolean;
  isMicrophoneMuted: boolean;
  participantsNumber: number;
  setCameraDisabled: (isDisabled: boolean) => void; 
  setMicrophoneMuted: (isMuted: boolean) => void;
  setParticipantsNumber: (number: number) => void;
}

const defaultValue: VideoCallContextType = {
  isCameraDisabled: false,
  isMicrophoneMuted: false,
  participantsNumber: 1,
  setCameraDisabled: () => {},
  setMicrophoneMuted: () => {},
  setParticipantsNumber: () => {},
};

const VideoCallContext = createContext<VideoCallContextType>(defaultValue);

export default VideoCallContext;